// The playlists you can page through in Now Playing (after the vignettes), in order.
// playlists.json holds each playlist's videos, copied from YouTube; the names
// below are the playlist titles and can be changed freely.
import PLAYLISTS from './playlists.json';

const IDS = [
  'PLdb-gmLYl9Ab5Ef43Mg5gg173TFar8_pk',
  'PLdb-gmLYl9AbteKyp9Cna7x2-3kNOT8yT',
  'PLdb-gmLYl9AZhXPriuQpk_VO8Wu6wmCpM',
  'PLdb-gmLYl9Aa-s_npbAwimI1z9c6YBZ63',
  'PLdb-gmLYl9AagaW2Ih9PUXBgyFKHWSWsy',
  'PLdb-gmLYl9AYyTm6ihxRNGyulU7e-10qJ',
  'PLdb-gmLYl9AYQoMMc7Z_QOSf651Z3PUE7',
  'PLdb-gmLYl9AbvS_Gn4g9Exd-F55iaOulT'
];

export const STATIONS = IDS.map(playlist => ({
  name: PLAYLISTS[playlist].name,
  playlist,
  videos: PLAYLISTS[playlist].videos
}));

// Wraps around at both ends
export const stepStation = (index, delta, count = STATIONS.length) => (((index + delta) % count) + count) % count;

export const playlistUrl = (station) => `https://www.youtube.com/playlist?list=${station.playlist}`;
